export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["Statuspending"] = "NOTIFICATION_STATUSPENDING";
    NotificationStatus["Statussent"] = "NOTIFICATION_STATUSSENT";
    NotificationStatus["Statusfailed"] = "NOTIFICATION_STATUSFAILED";
})(NotificationStatus || (NotificationStatus = {}));
